import {
  DialogActions as MuiDialogActions,
  DialogActionsProps as MuiDialogActionsProps,
  styled,
} from "@mui/material";

const StyledDialogActions = styled(MuiDialogActions)(() => ({
  // ... existing styles
}));

interface DialogActionsProps extends MuiDialogActionsProps {
  children: React.ReactNode;
}

export const DialogActions: React.FC<DialogActionsProps> = ({ children, ...props }) => {
  return <StyledDialogActions {...props}> {children}</StyledDialogActions>;
};

export default DialogActions;
